import { Reveal, SectionHeader } from "./Reveal";
import { ASSETS } from "../data/content";

export const Story = () => (
  <section id="story" data-testid="story-section" className="grain relative bg-ink py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-12 lg:px-10">
      <Reveal className="lg:col-span-5">
        <div className="relative">
          <div className="absolute -left-4 -top-4 h-full w-full border border-gold/30" aria-hidden="true" />
          <img
            src={ASSETS.paul}
            alt="Paul Manku, Founder of Legacy Custom Homes"
            loading="lazy"
            className="relative aspect-[4/5] w-full object-cover"
            data-testid="story-owner-photo"
          />
          <div className="absolute -bottom-6 -right-4 bg-gold px-6 py-4 md:-right-8">
            <p className="font-accent text-[10px] font-semibold uppercase tracking-[0.25em] text-black">
              Paul Manku — Founder
            </p>
          </div>
        </div>
      </Reveal>

      <div className="lg:col-span-7 lg:pl-8">
        <SectionHeader eyebrow="Our Story" title="Building More Than Homes" />
        <Reveal delay={0.15}>
          <p className="mt-8 font-serif text-2xl font-medium leading-relaxed text-platinum md:text-3xl" data-testid="story-opening">
            "Every home has a story. We believe the way it's built should become part of that
            legacy."
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mt-8 space-y-6 text-base leading-relaxed text-gray-400">
            <p>
              Legacy Custom Homes was created around a simple belief: a home should be built to
              last and designed to inspire. From fine homes with high-end finishes to complete
              transformations, every project is approached with the same standard — great quality,
              honest work, and craftsmanship our clients fall in love with.
            </p>
            <p>
              We work closely with every homeowner from the first conversation to the final
              walkthrough, because the relationship matters as much as the result. Whether it's one
              area of your home or a brand-new custom build, the goal never changes: create
              something made to last.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.35}>
          <div className="mt-10 flex items-center gap-4">
            <span className="h-px w-12 bg-gold" aria-hidden="true" />
            <p className="font-accent text-xs font-semibold uppercase tracking-[0.25em] text-gray-300">
              Built to Last. Designed to Inspire.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
